module.exports = __webpack_public_path__ + "img/OKT.5cf837c8.svg";